<template>
    <div class="printOrderListBox">
        <el-tabs v-model="activeName" class="orderListTabs" @tab-click="search">
            <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.name" :name="item.id">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <el-date-picker
                    v-model="evaluationTimeValue"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="评论开始日期"
                    end-placeholder="评论结束日期">
                </el-date-picker>
                <!--<el-input v-model="evaluationContentValue" placeholder="评价内容"></el-input>-->
                <!--<el-input v-model="facilitatorNameValue" placeholder="服务商名称"></el-input>-->
                <!--<el-select v-model="isAdditionalReview" placeholder="是否可追评">-->
                    <!--<el-option label="是" value="是"> </el-option>-->
                    <!--<el-option label="否" value="否"> </el-option>-->
                <!--</el-select>-->
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <!--<el-button type="text" class="resetBtn" @click="reset">-->
                    <!--<i class="iconfont icon-qingchushujuku"></i>-->
                    <!--<span>清除条件</span>-->
                <!--</el-button>-->
            </div>
            <div class="orderListTable">
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%" class="tableContent">
                    <el-table-column
                        label="评价内容"
                        min-width="400"
                        header-align="center">
                        <template slot-scope="scope">
                            <div class="commodityNameClass">
                                <div class="evaluateContent">
                                    <div class="name">{{scope.row.evaluate}} <span class="date">[{{scope.row.evaluateDate}}]</span></div>
                                </div>
                                <div class="tag">
                                    <div class="tagItem" v-for="(tag,index) in scope.row.tag" :key="index">
                                        {{tag}}
                                    </div>
                                </div>
                                <div class="newReplyList">
                                    <div v-for="(res,index) in scope.row.addedReplys" :key="index">
                                        <div class="review" v-show="res.evaluationType === 'ADDED'">
                                            <div class="title">用户{{getDiffYmdBetweenDate(scope.row.evaluateDate, res.createTime).d == 0 ? '当天' : getDiffYmdBetweenDate(scope.row.evaluateDate, res.createTime).d+'天后'}}追评：</div>
                                            <div class="content"> {{res.evaluationContent}} <span>[{{res.createTime}}]</span></div>
                                        </div>
                                        <div class="reply" v-show="res.evaluationType === 'REPLY'">
                                            <div class="content"><span style="color: #000;">商家回复： </span>{{res.evaluationContent}} <span>[{{res.createTime}}]</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="等级"
                        header-align="center"
                        align="center"
                        show-overflow-tooltip
                        width="300">
                        <template slot-scope="scope">
                            <div class="rate">
                                <div class="rateItem">
                                    <div class="name">描述相符</div>
                                    <el-rate
                                        v-model="scope.row.describe"
                                        disabled
                                        show-score
                                        text-color="#ff9900">
                                    </el-rate>
                                </div>
                                <div class="rateItem">
                                    <div class="name">服务态度</div>
                                    <el-rate
                                        v-model="scope.row.serve"
                                        disabled
                                        show-score
                                        text-color="#ff9900">
                                    </el-rate>
                                </div>
                                <div class="rateItem">
                                    <div class="name">专业程度</div>
                                    <el-rate
                                        v-model="scope.row.logistics"
                                        disabled
                                        show-score
                                        text-color="#ff9900">
                                    </el-rate>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="sellerName != '自营'"
                        :label="sellerName"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <div class="merchantInfo">
                                <span>{{scope.row.facilitator}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="订单信息"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"
                        width="300">
                        <template slot-scope="scope">
                            <div class="orderInfo">
                               <div class="name">{{scope.row.name}}</div>
                                <div class="price">￥{{scope.row.price}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        header-align="center"
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <div class="operationButtonGroup">
                                <el-button size="small" class="replyEvaluation" @click="toReply(scope.row)">追评</el-button>
                                <el-button type="text" size="small" class="replyEvaluation"  @click="toDetail(scope.row)">订单详情</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
                </el-pagination>
            </div>
        </div>


        <!--追评-->
        <el-dialog
            title="追评"
            :visible.sync="replyDialogVisible"
            width="500px">
            <div class="replyDialogContent">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4}"
                    placeholder="追评"
                    v-model="evaluateForm.evaluationContent">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="replyDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="replySubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getEvaluationList,saveEvaluation
    } from "../../utils/interface";
    export default {
        data() {
            return {
                form:{},
                activeName: 'PRINT',
                tabList: [
                    {
                        id: 'PRINT',
                        name: '打印订单'
                    },
                    {
                        id: 'SHOP',
                        name: '商城订单'
                    },
                    {
                        id: 'DESIGN',
                        name: '设计订单'
                    },
                    {
                        id: 'MODEL',
                        name: '模型订单'
                    },
                    {
                        id: 'SERVICE',
                        name: '服务订单'
                    },
                    {
                        id: 'SOFTWARE',
                        name: '软件订单'
                    }
                ],
                evaluationTimeValue: null,
                evaluationContentValue: '',
                facilitatorNameValue: '',
                isAdditionalReview: '',
                activeBuyerReview: '0',
                buyerReview: [
                    {
                        id: '0',
                        name: '已追评'
                    },
                    {
                        id: '1',
                        name: '未追评'
                    }
                ],
                activeBusinessReply: '0',
                businessReply: [
                    {
                        id: '0',
                        name: '已回复'
                    },
                    {
                        id: '1',
                        name: '未回复'
                    }
                ],
                tableData: [
                    {
                        uuid: '0',
                        evaluate: '很好！非常好！',
                        evaluateDate: '2021-09-01 12：25：35',
                        tag: ['质量好', '态度好', '服务好', '物流快'],
                        review: [
                            {
                                content: '非常好用，价格实惠 。',
                                time: '10',
                                createDate: '2021-09-11 12:25:35'
                            },
                            {
                                content: '非常好用，价格实惠 。',
                                time: '2',
                                createDate: '2021-09-12 12:25:35'
                            },
                            {
                                content: '非常好用，价格实惠 。',
                                time: '2',
                                createDate: '2021-09-13 12:25:35'
                            }
                        ],
                        reply: [
                            {
                                content: '尊敬的用户您好，非常感谢您选择本公司产品。',
                                time: '10',
                                createDate: '2021-09-09 12:25:35'
                            },
                            {
                                content: '尊敬的用户您好，非常感谢您选择本公司产品。',
                                time: '2',
                                createDate: '2021-09-10 12:25:35'
                            },
                            {
                                content: '尊敬的用户您好，非常感谢您选择本公司产品。',
                                time: '2',
                                createDate: '2021-09-14 12:25:35'
                            }
                        ],
                        facilitator: '安徽隆源成型科技有限公司',
                        name: '哆啦A梦.stl',
                        price: '53',
                        describe: 5,
                        serve: 5,
                        logistics: 5
                    },
                    {
                        uuid: '1',
                        evaluate: '很好！非常好！很好！非常好！很好！非常好！很好！非常好！很好！非常好！',
                        evaluateDate: '2021-09-01 12：25：35',
                        tag: ['质量好', '态度好', '服务好', '物流快', '物流快', '物流快', '物流快', '物流快', '物流快', '物流快', '物流快'],
                        review: [
                            {
                                content: '非常好用，价格实惠 。',
                                time: '10',
                                createDate: '2021-09-11 12:25:35'
                            },
                            {
                                content: '非常好用，价格实惠 。',
                                time: '2',
                                createDate: '2021-09-12 12:25:35'
                            }
                        ],
                        reply: [
                            {
                                content: '尊敬的用户您好，非常感谢您选择本公司产品。',
                                time: '2',
                                createDate: '2021-09-14 12:25:35'
                            }
                        ],
                        facilitator: '安徽隆源成型科技有限公司',
                        name: '哆啦A梦.stl',
                        price: '53',
                        describe: 3,
                        serve: 3,
                        logistics: 3
                    }
                ],
                current: 1,
                total: 0,
                pageSize: 10,
                replyDialogVisible: false,
                evaluateForm: {
                    evaluationContent: ''
                },
                evaluate: {},
                sellerName:'服务商名称'
            }
        },
        mounted(){
          // this.listDateSort()
        },
        created() {
            this.search();
        },
        methods: {
            // 分页
            handleCurrentChange(val) {
                this.current = val
                this.search();
            },
            // 重置
            reset() {
                this.evaluationTimeValue = null
                this.evaluationContentValue = ''
                this.facilitatorNameValue = ''
                this.isAdditionalReview = ''
                this.form.inputDate = "";
            },
            // 数组按照时间排序
            listDateSort(){
                this.tableData.map(item=>{
                    item.review.map(review=>{
                        this.$set(review,'status','review')
                    })
                    item.reply.map(reply=>{
                        this.$set(reply,'status','reply')
                    })
                    let newReplyList = item.review.concat(item.reply)
                    newReplyList.sort(function(a, b) {
                        let obj1 = a['createDate']
                        let obj2 = b['createDate']
                        const val1 = Math.floor(new Date(obj1).getTime() / 1000)
                        const val2 = Math.floor(new Date(obj2).getTime() / 1000)
                        return val1 - val2
                    })
                    this.$set(item,'newReplyList',newReplyList)
                })
            },
            // 点击打开评价追评弹出框
            toReply(evaluate){
                this.evaluate = evaluate.order;
                this.evaluateForm.evaluationContent = ''
                this.replyDialogVisible = true
            },
            // 追评提交
            replySubmit(){
                if(this.evaluateForm.evaluationContent){
                    this.evaluateForm.orderType = this.activeName;
                    this.evaluateForm.evaluationType = 'ADDED';
                    this.evaluateForm.evaluationId = this.evaluate.uuid;
                    this.evaluateForm.orderNo = this.evaluate.orderNo;
                    this.evaluateForm.orderUuid = this.evaluate.orderUuid;

                    saveEvaluation(this.evaluateForm).then((response) => {
                        if (response.success) {
                            this.replyDialogVisible = false
                            this.search();
                            this.$message({
                                type: "success",
                                message: "追评成功",
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                } else {
                    this.$message.warning('请输入追评内容！')
                }
            },
            search() {
                if(this.activeName == 'PRINT' || this.activeName == 'SERVICE'){
                    this.sellerName = '服务商名称';
                }else if(this.activeName == 'SHOP'){
                    this.sellerName = '店铺名称';
                }else if(this.activeName == 'DESIGN' || this.activeName == 'MODEL'){
                    this.sellerName = '设计师名称';
                }else if(this.activeName == 'SOFTWARE'){
                    this.sellerName = '自营';
                }
                if(this.evaluationTimeValue != null){
                    this.form.inputDate = this.evaluationTimeValue.join(" - ");
                }
                this.form.orderType = this.activeName;
                this.form.evaluationType = 'NORMAL';
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                getEvaluationList(this.form).then((res) => {
                    this.tableData = [];
                    console.log(res);
                    if (res != null && res.list !=null && res.list.length > 0) {
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let evaluation = {};
                            evaluation.order = item;
                            evaluation.uuid = item.uuid;
                            evaluation.evaluate = item.evaluationContent;
                            evaluation.evaluateDate = item.createTime;
                            let tags = [];
                            if(item.evaluationTagList != null && item.evaluationTagList.length > 0){
                                item.evaluationTagList.forEach((item, index) => {
                                    tags.push(item.tagName);
                                });
                            }
                            evaluation.tag = tags;
                            evaluation.facilitator = item.sellerName;
                            evaluation.name = item.orderName;
                            evaluation.price = item.orderAmount;
                            evaluation.describe = parseInt(item.descriptionPoint);
                            evaluation.serve = parseInt(item.servicePoint);
                            evaluation.logistics = parseInt(item.transportPoint);
                            evaluation.addedReplys = item.addedReplys
                           /* let review = [];
                            let reply = [];
                            if(item.addedReplys != null && item.addedReplys.length > 0){
                                item.addedReplys = item.addedReplys.map((item, index) => {
                                    if(item.evaluationType == 'ADDED'){
                                        this.$emit
                                        review.push({content : item.evaluationContent, time : this.getDiffYmdBetweenDate(evaluation.evaluateDate, item.createTime).d, createDate : item.createTime});
                                    }else if(item.evaluationType == 'REPLY'){
                                        reply.push({content : item.evaluationContent, time : this.getDiffYmdBetweenDate(evaluation.evaluateDate, item.createTime).d, createDate : item.createTime});
                                    }
                                });
                            }
                            // evaluation.review = review;
                            // evaluation.reply = reply;*/
                            this.tableData.push(evaluation);
                            console.log(this.tableData);
                        });
                    } else {
                        this.total = 0;
                    }
                });
            },
            getDiffYmdBetweenDate(sDate1,sDate2){
                var fixDate = function(sDate){
                    var aD = sDate.split('-');

                    for(var i = 0; i < aD.length; i++){
                        aD[i] = fixZero(parseInt(aD[i]));

                    }

                    return aD.join('-');

                };

                var fixZero = function(n){
                    return n < 10 ? '0'+n : n;

                };

                var fixInt = function(a){
                    for(var i = 0; i < a.length; i++){
                        a[i] = parseInt(a[i]);

                    }

                    return a;

                };

                var getMonthDays = function(y,m){
                    var aMonthDays = [0,31,28,31,30,31,30,31,31,30,31,30,31];

                    if((y%400 == 0) || (y%4==0 && y%100!=0)){
                        aMonthDays[2] = 29;

                    }

                    return aMonthDays[m];

                };

                var checkDate = function(sDate){
                };

                var y = 0;

                var m = 0;

                var d = 0;

                var sTmp;

                var aTmp;

                sDate1 = fixDate(sDate1);

                sDate2 = fixDate(sDate2);

                if(sDate1 > sDate2){
                    return 'past'

                }

                var aDate1 = sDate1.split('-');

                aDate1 = fixInt(aDate1);

                var aDate2 = sDate2.split('-');

                aDate2 = fixInt(aDate2);

//计算相差的年份

                /*aTmp = [aDate1[0]+1,fixZero(aDate1[1]),fixZero(aDate1[2])];

                while(aTmp.join('-') <= sDate2){
                y++;

                aTmp[0]++;

                }*/

                y = aDate2[0] - aDate1[0];

                if( sDate2.replace(aDate2[0],'') < sDate1.replace(aDate1[0],'')){
                    y = y - 1;

                }

//计算月份

                aTmp = [aDate1[0]+y,aDate1[1],fixZero(aDate1[2])];

                while(true){
                    if(aTmp[1] == 12){
                        aTmp[0]++;

                        aTmp[1] = 1;

                    }else{
                        aTmp[1]++;

                    }

                    if(([aTmp[0],fixZero(aTmp[1]),aTmp[2]]).join('-') <= sDate2){
                        m++;

                    } else {
                        break;

                    }

                }

//计算天数

                aTmp = [aDate1[0]+y,aDate1[1]+m,aDate1[2]];

                if(aTmp[1] > 12){
                    aTmp[0]++;

                    aTmp[1] -= 12;

                }

                while(true){
                    if(aTmp[2] == getMonthDays(aTmp[0],aTmp[1])){
                        aTmp[1]++;

                        aTmp[2] = 1;

                    } else {
                        aTmp[2]++;

                    }

                    sTmp = ([aTmp[0],fixZero(aTmp[1]),fixZero(aTmp[2])]).join('-');

                    if(sTmp <= sDate2){
                        d++;

                    } else {
                        break;

                    }

                }

                return {y:y,m:m,d:d}

            },
            // 跳转至详情页
            toDetail(val){
                console.log(val)
                if(val.order.orderType === 'PRINT'){
                    this.$router.push({name:'printOrderDetails',params:{uuid:val.order.orderUuid,type: 'evaluate'}});
                }
                if(val.order.orderType === 'MODEL'){
                    this.$router.push({
                        path: "/modelOrderDetail",
                        query: {
                            uuid: val.order.orderUuid,
                            type: 'evaluate'
                        },
                    });
                }
                if(val.order.orderType === 'DESIGN'){
                    this.$router.push({name:'designOrderDetail',params:{uuid:val.order.orderUuid,type: 'evaluate'}});
                }
                if(val.order.orderType === 'SERVICE'){
                    this.$router.push({name:'serverOrderDetails',params:{uuid:val.order.orderUuid,type: 'evaluate'}});
                }
                if(val.order.orderType === 'SHOP'){
                    this.$router.push({name:'mallOrderDetails',params:{orderBaseUuid:val.order.orderUuid,type: 'evaluate'}});
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .printOrderListBox {
        padding: 94px 20px 20px;
        .orderListTabs {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #E4E7ED;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            /deep/.el-range-editor{
                    width: 450px !important;
                /deep/.el-range-input{
                    background: transparent;
                }
                /deep/.el-range__close-icon{
                    line-height: 28px;
                }
            }
            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom: 22px;
                margin-left: 20px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .orderListTable {
            .tableTool {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .toolItem {
                    display: flex;
                    align-items: center;
                    margin-right: 50px;

                    .name {
                        font-weight: 400;
                        font-size: 13px;
                        color: #BCBCBC;
                        padding-right: 10px;
                    }

                    ul {
                        display: flex;

                        li {
                            margin-right: 5px;
                            padding: 5px 10px;
                            font-size: 13px;
                            color: #6B6B6B;
                            background-color: rgba(54, 134, 215, 0.12);
                            cursor: pointer;

                            &.active {
                                background-color: rgba(54, 134, 215, 1);
                                color: #fff;
                            }
                        }
                    }
                }
            }

            .tableContent {
                min-height: 540px;

                .commodityNameClass {
                    .evaluateContent{
                        display: flex;
                        font-size: 13px;
                        margin-bottom: 15px;
                        .name{
                            color: #333333;
                            span{
                                color: #949494;
                            }
                        }
                    }
                    .tag{
                        display: flex;
                        flex-wrap: wrap;
                        .tagItem{
                            font-size: 13px;
                            color: #333333;
                            padding: 5px 20px;
                            background: #f2f2f2;
                            border-radius: 20px;
                            margin: 0 10px 10px 0;
                        }
                    }
                    .reply{
                        padding: 10px;
                        width: 100%;
                        background: #f2f2f2;
                        border-radius: 4px;
                        color: #333333;
                        font-size: 13px;
                        margin-bottom: 15px;
                        span{
                            color: #949494;
                        }
                    }
                    .review{
                        padding: 10px;
                        width: 100%;
                        font-size: 13px;
                        margin-bottom: 15px;
                        border-top: 1px dashed #ddd;
                        .title{
                            line-height: 30px;
                            color: #3977F3;
                        }
                        .content{
                            color: #333333;
                            text-indent: 30px;
                            span{
                                color: #949494;
                            }
                        }
                    }
                }
                .rateItem{
                    display: flex;
                    padding: 5px 0;
                    width: 200px;
                    margin: 0 auto;
                    .name{
                        font-size: 13px;
                        color: #999999;
                        padding-right: 10px;
                    }
                }
                .merchantInfo{
                    font-size: 13px;
                    color: #333333;
                    i{
                        font-size: 20px;
                        padding-left: 5px;
                        color: #3d7fff;
                    }
                }
                .operationButtonGroup{
                    button{
                        display: block;
                        margin: 0 auto;
                        &.replyEvaluation{
                            width: 90px;
                            // padding: 6px 20px;
                            padding: 0;
                            text-align: center;
                            line-height:34px;
                            font-weight: 700;
                            font-size: 14px;
                            color: rgba(0, 102, 204, 0.79);
                            border-radius: 6px;
                            border: 1px solid rgba(0, 102, 204, 0.79);
                            margin-top: 12px;
                            &:nth-last-of-type(1) {
                                margin-bottom: 12px;
                            }
                        }
                        &.orderDetails{
                            padding-top: 16px;
                            width: 90px;
                            text-align: center;
                            margin: 0 auto;
                            color: rgba(0, 102, 204, 0.79);
                        }
                    }
                }
                .orderInfo{
                    .name{
                        font-size: 14px;
                        color: #333333;
                    }
                    .price{
                        font-size: 14px;
                        font-weight: 700;
                        color: #3977F3;
                    }
                }
                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }

                    /deep/ .el-table__row {
                        td {
                            border-right: none;

                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
    .replyDialogContent{
        display: flex;
        .name{
            min-width: 50px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/evaluationManagement.vue